import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { Relayout, RelayoutItem } from 'relayout'

import SecondaryButton from 'components/secondary-button'
import { formatShortDateTimeNice } from 'utils/datetime'
import { formatPriceDecimals, currencySymbol } from 'utils/format'

import styles from './promo-code-list-item.css'

const PromoCodeListItem = ({ code, appliesToText, onEditClick }) => (
  <Relayout gutter={false} styleName="promo-code-list-item">
    <RelayoutItem sm="6" lg="3">
      <div styleName="field"><strong>{code.name}</strong></div>
    </RelayoutItem>
    <RelayoutItem sm="6" lg="2">
      <div styleName="field">{currencySymbol('GBP')}<strong>{formatPriceDecimals(code.value)}</strong></div>
    </RelayoutItem>
    <RelayoutItem sm="12" lg="4">
      <div styleName="field">
        <span styleName="validity">from</span> <strong>{formatShortDateTimeNice(code.onsaleTime)}</strong> <br />
        <span styleName="validity">to</span> <strong>{formatShortDateTimeNice(code.offsaleTime)}</strong>
      </div>
    </RelayoutItem>
    <RelayoutItem sm="12" lg="3">
      <div styleName="field">
        <strong>{code.totalLimit}</strong> times total <br /> <strong>{code.limitPerCustomer}</strong> time per customer
      </div>
    </RelayoutItem>

    <RelayoutItem sm="9">
      <div styleName="description">
        Applies to <strong>{appliesToText}</strong>
      </div>
    </RelayoutItem>
    <RelayoutItem sm="3">
      <div styleName="actions">
        <div styleName="button">
          <SecondaryButton label="Edit" onClick={onEditClick} />
        </div>
      </div>
    </RelayoutItem>

  </Relayout>
)

PromoCodeListItem.propTypes = {
  code: PropTypes.object,
  appliesToText: PropTypes.string,
  onEditClick: PropTypes.func.isRequired,
}

export default CSSModules(PromoCodeListItem, styles)



/** WEBPACK FOOTER **
 ** ./src/components/promo-code-list/promo-code-list-item/promo-code-list-item.js
 **/